/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from "react";
import { Page, Document } from "@react-pdf/renderer";
import PlayerRosterTable from "./PlayerRosterTable";
import Header from "./Header";
import Notes from "./Notes";
import ProductImage from "./ProductImage";
import DataTree from "./DataTree";
import styles from "./styles";
import { getImage } from "api/services/shareDesign.api";
import { ArrayOfArrays } from "interfaces/ShareDesign/IShareDesign";

const Pdf = ({
  brandLogo,
  productImages,
  productDetails,
  billingInformation,
  playerRoster,
}: any) => {
  const [pdfImgUrl, setPdfImgUrl] = useState<ArrayOfArrays>([]);

  useEffect(() => {
    const fetchData = async () => {
      const arr = JSON.parse(JSON.stringify([...productImages]));

      if (productImages.length > 0) {
        const promises = productImages.map((productImage: any, index1: number) => {
          if (!productImage[0].img.includes("artifi"))
            return Promise.all(
              productImage.map(async (imgData: any, index2: number) => {
                const res = await getImage(imgData.img);
                arr[index1][index2] = res.data;
              })
            );
        });

        await Promise.all(promises);
        setPdfImgUrl([...arr]);
      }
    };

    fetchData();
  }, [productImages]);

  return (
    <Document>
      <Page size="A4" orientation="portrait" style={styles.page} wrap>
        <Header brandLogo={brandLogo} billingInformation={billingInformation} />
        <ProductImage productImages={productImages} pdfImgUrl={pdfImgUrl} />
      </Page>
      <DataTree productDetails={productDetails} />
      <Page size="A4" orientation="portrait" style={styles.page} wrap>
        <Notes billingInformation={billingInformation} />
        <PlayerRosterTable playerRoster={playerRoster} />
      </Page>
    </Document>
  );
};

export default Pdf;
